module.exports = __webpack_public_path__ + "img/21.74b92f1d.jpg";